import React, { useEffect } from "react";
import { CloseIcon } from "../../../components/Icons";
import { useModal } from "../../../context/ModalContext";
import { StyledBookingFlowButton } from "../../containers/BookingScheduleContainer/BookingScheduleContainer.style";
import { useNavigate } from "react-router-dom";
import { PAGES_PATH } from "../../../navigation/params";
import { useMediaQuery } from "@mui/material";
import { userActivityLogger } from "../../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import { REFERRAL_ADVOCATE_AMOUNT } from "../../../config/params";

const InviteUpsellModal = () => {
  const { closeModal } = useModal();
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery("(max-width: 460px)");
  const smallScreenImage = "/assets/icons/refer-friends-dog-pic.png";
  const largeScreenImage = "/assets/icons/invite-friends.jpg";

  const handleModalClose = (source?: "maybeLaterCta") => {
    if (source === "maybeLaterCta") {
      userActivityLogger(MIXPANEL_EVENTS.MAYBE_LATER_CLICKED, {
        user_session_type: "logged_in",
      });
    } else {
      userActivityLogger(MIXPANEL_EVENTS.UPSELL_MODAL_DISMISSED, {
        user_session_type: "logged_in",
      });
    }
    closeModal();
  };

  const handleInvite = () => {
    navigate(PAGES_PATH.REFER_FRIEND);
    userActivityLogger(MIXPANEL_EVENTS.INVITE_FRIENDS_CLICKED, {
      user_session_type: "logged_in",
    });
    closeModal();
  };

  useEffect(() => {
    userActivityLogger(MIXPANEL_EVENTS.UPSELL_MODAL_SHOWN, {
      source: "upsell",
    });
  }, []);

  return (
    <div className="flex flex-col sm:flex-row
     w-80 sm:w-full lg:max-w-2xl text-center overflow-y-auto rounded-2xl">

      {/* Image div */}
      <div className="w-full h-32 sm:h-auto">
        <img src={isSmallScreen ? smallScreenImage : largeScreenImage}
          className="mx-auto object-cover w-full h-full" alt="invite friends image" />
      </div>

      <div className="p-4 w-full h-2/5 md:h-80 flex flex-col self-end">
        <div className="flex justify-end">
          <CloseIcon
            onClick={handleModalClose}
            className="text-black cursor-pointer fixed top-2 right-2 bg-stone-50
             sm:bg-none rounded-full md:rounded-none"
          />
        </div>
        <div className="flex flex-col justify-between h-full">
          <div>
            <h3 className="text-2xl grenette-pro text-center">Invite Friends and Get {REFERRAL_ADVOCATE_AMOUNT}!</h3>
            <p className="text-sm text-center lg:px-2 ">
           Share the care and get rewarded! Invite friends to GoodVets and you&apos;ll
           earn {REFERRAL_ADVOCATE_AMOUNT} in credits when they complete their first visit.
            </p>
          </div>
          <div className="w-full flex flex-col items-center gap-2 mt-4">
            <StyledBookingFlowButton
              color="primary"
              size="small"
              className="w-full"
              onClick={handleInvite}
            >
          Invite Friends
            </StyledBookingFlowButton>
            <StyledBookingFlowButton
              color="primary"
              size="small"
              className={"!bg-transparent w-full !border-gray-3 hover:!bg-gray-3 !text-black}"}
              onClick={()=>handleModalClose("maybeLaterCta")}
            >
            Maybe Later
            </StyledBookingFlowButton>

          </div>
        </div>
      </div>
    </div>
  );
};

export default InviteUpsellModal;
